import React from 'react';
import { Form, Button, InputNumber, Input, message, Modal } from 'antd';
import { License, ELicenseType } from 'types/common';
import { FormLicense } from 'types/form';
import s from './s.module.less';
import commonS from 'styles/common.module.less';
import FileUpload from 'components/form/FileUpload';
import { providerLicenseUpdate } from 'api/provider';
import { opLicenseUpdate } from 'api/operation';
import { getFileNameFromUrl } from 'utils/common';
import { FormMutipleLicense } from 'types/provider';
import { LicenseData } from 'data/provider';
import LicenseImg from 'components/LicenseImg';

type Props = {
    inited?:boolean,
    initValue?: FormMutipleLicense,
    state:string,
    providerId?:number,
    onChange?: (value:FormMutipleLicense)=>void
    viewOnly?:boolean,
    onNullState?: ()=>void,
    isOperation?:boolean,
};

const ContinuingMedicalEducationCertificates = (props: Props) => {
    const { inited = false, initValue, state, providerId, onChange, viewOnly, onNullState, isOperation } = props;
    const [submiting, setSubmiting] = React.useState(false);

    //enable and show modal is little function cover..

    const [enable, setEnable] = React.useState(!!inited);

    //mean already filled and display modal
    const [showModal, setShowModal] = React.useState(false);
    const [form] = Form.useForm<FormMutipleLicense>();
    const [,forceUpdate] = React.useState({});

    const onSubmit = async () => {
        try {
            setSubmiting(true);
            const formValues = await form.validateFields();
            const licenseArrary = formValues.licenses || [];
            const addData:Partial<FormLicense>[] = [];
            for (let i = 0; i < licenseArrary.length; i++) {
                const data = licenseArrary[i];
                const licenseData:Partial<License> = {
                    type: ELicenseType.CONTINUING_MEDICAL_EDUCATION_CERTIFICATES,
                    secondType: `${i + 1}`,
                    state,
                    licenseNumber: data.licenseNumber,
                    schedule: data?.schedule?.join(','),
                    url: data.url,
                    classTitle: data.classTitle,
                    certificatedTitle: data.certificatedTitle,
                    hourCompleted: data.hourCompleted,
                };
                const fn = isOperation ? opLicenseUpdate : providerLicenseUpdate;
                // eslint-disable-next-line no-await-in-loop
                const result = await fn(licenseData, providerId!);
                if (result.error) {
                    message.error(result.error);
                    return;
                } else {
                    addData.push(LicenseData.serverToForm(licenseData as License));
                }
            }
            message.success('Continuing Medical Education Certificates info has updated');
            setEnable(true);
            setShowModal(false);
            if (onChange) {
                onChange({
                    licenses: addData,
                });
            }
        } catch (e:any) {
            if (e.errorFields) {
                //form error
                return;
            }
            const msg = e?.toString?.() || 'data error';
            message.error(msg);
        } finally {
            setSubmiting(false);
        }
    };

    React.useEffect(() => {
        if (initValue) {
            form.setFieldsValue(initValue);
            forceUpdate({});
        }
    }, []);
    const licensesArray:FormLicense[] = form.getFieldValue('licenses')?.filter((item:FormLicense) => !!(item && item.licenseNumber));

    return (
        <div className={`${s.wrap} ${enable ? s.display : ''}`}>
            <h3>
                <div className={s.left}>
                    {!enable && (
                        <span
                            onClick={() => {
                                if (!state) {
                                    onNullState?.();
                                    return;
                                }
                                setShowModal(true);
                            }}
                            className={commonS.addIcon}
                            style={{ marginRight: 16 }}
                        />)}
                    <span>Continuing Medical Education Certificates</span>
                </div>
                {enable && !viewOnly &&
                <Button
                    size="small"
                    onClick={() => {
                        if (!state) {
                            onNullState?.();
                            return;
                        }
                        setShowModal(true);
                    }}
                >
                    Edit
                </Button>}
            </h3>
            {
                enable &&
                <div>
                    {
                        licensesArray?.map((item:FormLicense) => {
                            return (
                                <div className={s.subModule} key={item.licenseNumber}>
                                    <div className={s.row}>
                                        <div
                                            style={{
                                                width: '320px',
                                            }}
                                            className={s.displayItem}
                                        >
                                            <div className={s.label}>CME number</div>
                                            <div className={s.value}>{item.licenseNumber }</div>
                                        </div>
                                        <div
                                            style={{
                                                width: '320px',
                                            }}
                                            className={s.displayItem}
                                        >
                                            <div className={s.label}>Certificated title</div>
                                            <div className={s.value}>{ item.certificatedTitle}</div>
                                        </div>
                                        <div
                                            style={{
                                                width: '320px',
                                            }}
                                            className={s.displayItem}
                                        >
                                            <div className={s.label}>Class title</div>
                                            <div className={s.value}>{ item.classTitle}</div>
                                        </div>
                                    </div>
                                    <div className={s.row}>
                                        <div
                                            style={{
                                                width: '320px',
                                            }}
                                            className={s.displayItem}
                                        >
                                            <div className={s.label}>Hours completed</div>
                                            <div className={s.value}>{ item.hourCompleted}</div>
                                        </div>
                                    </div>
                                    <div className={s.row}>
                                        <div
                                            style={{
                                                width: '80%',
                                            }}
                                            className={s.displayItem}
                                        >
                                            <div className={s.label}>Uploaded license</div>
                                            <div className={s.value}>
                                                <LicenseImg src={item.url} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            }
            <Modal
                title="Continuing medical education certificates"
                closable
                className={commonS.modalFixHeightWrap}
                width="80%"
                onCancel={() => {
                    setShowModal(false);
                }}
                okText="Save"
                open={showModal}
                onOk={onSubmit}
                destroyOnClose
                okButtonProps={{ loading: submiting }}
            >
                <Form
                    form={form}
                    name="basic"
                    className={commonS.formStyle1}
                    initialValues={{ remember: true }}
                    autoComplete="off"
                    layout="vertical"
                >
                    <Form.List name="licenses" initialValue={[{}]}>
                        {(fields, { add, remove }) => {
                            const { length } = fields;
                            return (
                                <div id="cmecLicense">
                                    {fields.map((field) => {
                                        return (
                                            <Form.Item
                                                key={field.key}
                                                noStyle
                                            >
                                                <div className={s.modalWrap}>
                                                    <div className={s.row}>
                                                        <div className={s.rowItem}>
                                                            <Form.Item
                                                                style={{ width: '320px' }}
                                                                label="CME number"
                                                                name={[field.name, 'licenseNumber']}
                                                                validateFirst
                                                                rules={[
                                                                    { required: true, message: 'CME License number is required' },
                                                                ]}
                                                            >
                                                                <Input type="number" placeholder="What is the CME license number?  " />
                                                            </Form.Item>
                                                        </div>
                                                        <div className={s.rowItem}>
                                                            <Form.Item
                                                                style={{ width: '320px' }}
                                                                label="Certificated title"
                                                                name={[field.name, 'certificatedTitle']}
                                                                rules={[{ required: true, message: 'Certificated title is required' }]}
                                                            >
                                                                <Input />
                                                            </Form.Item>
                                                        </div>
                                                        <div className={s.rowItem}>
                                                            <Form.Item
                                                                style={{ width: '320px' }}
                                                                label="Class title"
                                                                name={[field.name, 'classTitle']}
                                                                rules={[{ required: true, message: 'Class title is required' }]}
                                                            >
                                                                <Input />
                                                            </Form.Item>
                                                        </div>
                                                    </div>
                                                    <div className={s.rowItem}>
                                                        <Form.Item
                                                            style={{ width: '320px' }}
                                                            label="Hours completed"
                                                            name={[field.name, 'hourCompleted']}
                                                            rules={[{ required: true, message: 'Hours completed is required' }]}
                                                        >
                                                            <InputNumber controls={false} />
                                                        </Form.Item>
                                                    </div>
                                                    <div className={s.rowItem}>
                                                        <Form.Item
                                                            style={{ width: '500px' }}
                                                            label="License copy"
                                                            name={[field.name, 'url']}
                                                            rules={[{ required: true, message: 'License copy is required' }]}
                                                        >
                                                            <FileUpload />
                                                        </Form.Item>
                                                    </div>
                                                    {field.name !== 0 &&
                                                    <div className={s.removeWrap}>
                                                        <Button
                                                            onClick={() => {
                                                                remove(field.name);
                                                            }}
                                                            danger
                                                            size="small"
                                                        >Remove
                                                        </Button>
                                                    </div> }
                                                    {field.name === length - 1 &&
                                                    <div
                                                        onClick={() => {
                                                            add();
                                                            const wrap = document.getElementById('cmecLicense');
                                                            setTimeout(() => {
                                                                wrap?.parentElement?.parentElement?.scroll({
                                                                    top: 1000000,
                                                                    behavior: 'smooth',
                                                                });
                                                            }, 200);
                                                        }}
                                                        className={s.add}
                                                    >
                                                        + Add another CME certificates
                                                    </div>
                                                    }
                                                </div>
                                            </Form.Item>);
                                    })}
                                </div>);
                        }}
                    </Form.List>
                </Form>
            </Modal>
        </div>
    );
};

export default ContinuingMedicalEducationCertificates;
